import { Component } from '@angular/core';
import { DotPulseComponent } from '../../../../../../../../../../../../shared/components/dot-pulse/dot-pulse.component';

@Component({
  selector: 'app-self-send',
  imports: [DotPulseComponent],
  templateUrl: './self-send.component.html',
  styleUrl: './self-send.component.scss',
})
export class SelfSendComponent {}
